import { render, staticRenderFns } from "./SelectRegDateModal.vue?vue&type=template&id=1edf0bb7&"
import script from "./SelectRegDateModal.vue?vue&type=script&lang=ts&"
export * from "./SelectRegDateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports